export default "__VITE_ASSET__dcbf482f__"